import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "@/lib/site-data";

export default function FAQ() {
  return (
    <section data-testid="faq-section" id="faq" className="py-24 lg:py-32 bg-[#F4F9FC]">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="text-[11px] uppercase tracking-[0.22em] text-[#D4AF37] font-semibold">FAQs</div>
          <h2 className="font-heading mt-3 text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight">
            Things our clients <span className="gold-gradient-text font-medium">ask us</span>.
          </h2>
        </div>
        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-[#E5E5E5]" data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="font-heading text-left text-base lg:text-lg font-medium text-[#0A0A0A] hover:no-underline hover:text-[#D4AF37]">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#4B5563] text-sm lg:text-base leading-relaxed">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
